module.exports = __webpack_public_path__ + "static/media/IconModalAcessoSistema.42c7fea5.svg";